import type { LogoProps } from '../logo.types';
import whiteLarge from '../../../assets/logos/icon-drogasil-white-large.svg';
import whiteHuge from '../../../assets/logos/icon-drogasil-white-huge.svg';
import whiteEnormous from '../../../assets/logos/icon-drogasil-white-enormous.svg';

const sizeToImage = {
  large: whiteLarge,
  huge: whiteHuge,
  enormous: whiteEnormous,
};

const TITLE = "Drogasil White Icon"

const DrogasilIconWhite = ({ size, className }: LogoProps) => {
  return (
    <img
      title={TITLE}
      role='img'
      aria-labelledby={TITLE}
      src={sizeToImage[size ?? "large"]}
      alt={TITLE}
      className={className}
    />
  );
};

export default DrogasilIconWhite; 